import React, { useEffect, useState } from 'react';
import "./About.css";

function About() {
    let [mobile, setMobile] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (document.getElementById("root").clientWidth < 600) {
            setMobile(true);
        }
    }, []);

    return (
        <div className='about-container'>
            <div className='products-banner'>
                {!mobile && <img src={require("../../images/about/banner.avif")} alt="about-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require("../../images/about/banner-mobile.avif")} alt="about-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>About Us</span>
                    <span>Aero Fasteners Pvt. Ltd. is engaged in manufacturing and distribution of high quality fasteners and machined components specially catering to Aerospace segment.</span>
                </div>
            </div>
            <div className='about-header'>
                We have our manufacturing facilities at Rohtak in Haryana, which is about 45 KMs from western border of Delhi.
            </div>
            <div className='about-content'>
                The factory has in-house laboratory to ensure defect free products, since we understand the criticality of our components, which otherwise is considered to be a ‘C’ class item by many.
            </div>
            <div className='about-content'>
                <ul>
                    <li>We are an AS9100D certified Company.</li>
                    <li>Our objective is elevating aerospace excellence with precision-engineered, certified components for unmatched safety and performance.</li>
                    <li>We have tie up with Global companies for on time and quality Raw Materials.</li>
                    <li>Our vision is to be India’s no. 1 Aerospace Fasteners company by 2028.</li>
                </ul>
            </div>
            <div className='about-middle'>
                <img src={require("../../images/about/image.avif")} alt="about-middle" height={"100%"} width={"100%"} />
                <div className='about-middle-content'>
                    <div className='about-content-header'>Integrated Process for Superior Fasteners</div>
                    <div>
                        At Aero Fasteners, we ensure top-quality aerospace components through our integrated process:
                    </div>
                    <ul>
                        <li><strong>Hot Forging:</strong> Shapes high-strength materials for robust fasteners.</li>
                        <li><strong>Heat Treatment:</strong> Enhances hardness, strength, and durability.</li>
                        <li><strong>NDP Process:</strong> Ensures integrity and performance via rigorous testing.</li>
                    </ul>
                    <div>
                        Our comprehensive approach guarantees unmatched reliability and efficiency for all your aerospace needs.
                    </div>
                </div>
            </div>
            <div className='about-content'>
                <span>We keep below raw materials ex-stock for faster deliveries:-</span>
                <ul>
                    <li>30KhGSA, 25Kh17N2B, 16KhSN</li>
                    <li>SCM 435, 10B21, 4135, 51B37, 4340</li>
                    <li>EN 24 (ESR Grade), EN 9, EN 8, EN 8D, EN 1A</li>
                    <li>Aluminum : B65 (V65), AA5056, AA5052, AA2024, AA2017, AA2117, Alloy 2, Alloy 3, 24345, 19300, 52000</li>
                    <li>SS316, SS316L, SS304, SS304L, SS303, SS321, SS410, SS420, SS431, etc.</li>
                    <li>A286, 13-8PH, 15-5PH, 17-4PH, Ti6Al4V, Titanium Grade5, Grade2, Inconel</li>
                    <li>Brass CuZn37</li>
                    <li>Beryllium Copper</li>
                    <li>C15, 60C2A, Various Other Types of Spring Steels</li>
                </ul>
            </div>
            <div className='about-content'>
                <div className='about-content-header'>Our Professional Philosophy</div>
                <div>
                    We are committed to employing a skilled team that works together seamlessly to meet project goals. As a leading manufacturer of machined components, we ensure top-quality products at competitive prices and provide timely service to exceed customer expectations.
                </div>
            </div>
            {/* <div className='about-content'>
                <div className='about-content-header'>Manufacturing Capabilities</div>
                <div>
                    <span>At Aero Fasteners, we prioritize sustainability in every aspect of our operations. We are dedicated to using eco-friendly materials and processes to minimize our environmental impact. Our commitment includes:</span>
                    <ul>
                        <li><strong>Eco-Friendly Materials:</strong> We avoid using hazardous materials in our products, ensuring they are safe for both people and the planet.
                        </li>
                        <li><strong>Scrap Management:</strong> We have implemented efficient scrap management practices to reduce waste and recycle materials whenever possible.
                        </li>
                        <li><strong>Workforce Management:</strong> Our team is trained in sustainable practices, and we promote a culture of environmental responsibility throughout our organization.
                        </li>
                    </ul>
                    <span>By integrating these sustainability practices, we not only protect the environment but also ensure the health and safety of our workforce and the communities we serve.</span>
                </div>
            </div>
            <div className='about-content'>
                <span>Machined components range starts from 1mm dia.</span>
                <ul>
                    <li>Dowel Pin range starts from 1mm</li>
                    <li>Split Pin – ready stock available from 0.6mm</li>
                    <li>Slotted Round Nut & Hex Nut range starting M1.4</li>
                    <li>Anchor Nuts and Lock Nuts</li>
                    <li>Washers & Spacers</li>
                    <li>Studs</li>
                    <li>Solid Inserts</li>
                    <li>Wire Threaded Inserts</li>
                    <li>CNC / VMC based Machined Components</li>
                </ul>
            </div>
            <div className='about-content'>
                <span>Cold Forging capabilities starting from 1.6 mm</span>
                <ul>
                    <li>Machine Screw range starts from M1.6</li>
                    <li>CSK Head, Cheese Head, Pan Head, Round Head, Raised CSK, T Head, etc.</li>
                    <li>Hex, Socket, Square, Slotted, 100 / 120 Deg Cruciform, Phillips, Pozidrive, etc.</li>
                    <li>100% Burr Free Slotted Screws</li>
                    <li>Slotted Grub / Set Screws</li>
                    <li>Captive Screws</li>
                    <li>Safety Screws with Drill Hole</li>
                </ul>
            </div> */}
            <div className='about-content'>
                <div className='about-content-header'>Certificates</div>
                <div>
                    <ul>
                        <li><strong>Management System Certificate - </strong> <a href="https://firebasestorage.googleapis.com/v0/b/appyard-e37d6.appspot.com/o/aero%2FAS9100D_2022.pdf?alt=media&token=f15457ce-f813-462f-95fc-c5575a2d98dd" target="_blank" rel='noreferrer'>Click Here</a></li>
                        <li><strong>Certificate of Registration (ISO 14001:2015) - </strong> <a href="https://firebasestorage.googleapis.com/v0/b/appyard-e37d6.appspot.com/o/aero%2FISO_14001_040723.pdf?alt=media&token=6dbb6800-59e0-4b5e-9ba1-bd174e09fc54" target="_blank" rel='noreferrer'>Click Here</a>
                        </li>
                        <li><strong>Certificate of Registration (ISO/IEC 27001:2022) - </strong> <a href="https://firebasestorage.googleapis.com/v0/b/appyard-e37d6.appspot.com/o/aero%2FISO_27001_040723.pdf?alt=media&token=de8ee270-8d37-4fe9-843e-b87fd3828a83" target="_blank" rel='noreferrer'>Click Here</a>
                        </li>
                        <li><strong>Certificate of Registration (ISO 45001:2018) - </strong> <a href="https://firebasestorage.googleapis.com/v0/b/appyard-e37d6.appspot.com/o/aero%2FISO_45001_040723.pdf?alt=media&token=4e4638e9-3630-4b08-ba47-7c1c592933fc" target="_blank" rel='noreferrer'>Click Here</a>
                        </li>
                        <li><strong>Certificate of NABL (ISO 17025) - </strong> <a href="https://firebasestorage.googleapis.com/v0/b/appyard-e37d6.appspot.com/o/aero%2FNABL.pdf?alt=media&token=bf613f45-f1f3-4751-a72a-35a090e3e15a" target="_blank" rel='noreferrer'>Click Here</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default About
